import Doc from "./Doc";

function DocOut(props) {
  return (
    <Doc group={2} {...props} />
  );
}

export default DocOut;
